/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Registre } from '@/types';

import validationInformationsActe from '../validationInformationsActe';
import validationInformationsEvenementDeces from '../validationInformationsEvenementDeces';

/**
 * Validation de l'étape « Acte » pour le décès : informations de l'acte
 * (réutilisées telles quelles) + informations sur l'évènement. L'état civil du
 * défunt est validé séparément, dans son étape (`validationStepDefunt`).
 *
 * Aucune collision de clés entre les 2 blocs (`registre`/`sousTypeActe`/
 * `dateActe`/… vs `dateDeces`/`heureDeces`/`adresseDeces`).
 */
const validationStep1Deces = (
  data: Record<string, any>,
  selectedRegistre?: Partial<Registre>,
) => ({
  ...validationInformationsActe(data, selectedRegistre),
  ...validationInformationsEvenementDeces(data),
});

export default validationStep1Deces;
